import { memo } from 'react';

interface UserAvatarProps {
  avatarUrl: string | null;
  username: string;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Pure presentational component.
 * Shows avatar image if available, falls back to username initial.
 */
const UserAvatar = memo(function UserAvatar({
  avatarUrl,
  username,
  size = 'sm',
}: UserAvatarProps) {
  const initial = username.charAt(0).toUpperCase();

  if (avatarUrl) {
    return (
      <img
        className={`user-avatar user-avatar--${size}`}
        src={avatarUrl}
        alt={username}
        // Fallback to initial on broken URL
        onError={(e) => {
          e.currentTarget.style.display = 'none';
          const next = e.currentTarget.nextElementSibling as HTMLElement | null;
          if (next) next.style.display = 'flex';
        }}
      />
    );
  }

  return (
    <span className={`user-avatar user-avatar--${size} user-avatar--fallback`}>
      {initial}
    </span>
  );
});

export default UserAvatar;
